'use strict';

module.exports = require('ck-core-client/source/data/FooterEntries');
